import React, { useState, useEffect } from "react";
import { Typography, Grid, Container, Box } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import { useLocation } from "react-router-dom";
import ListGenericCard from "../../components/Custom/ListGenericCard";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/Custom/CustomButton";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import RequestSubmitPopup from "../../components/Popup/RequestSubmitPopup";

export default function LenderRequestDetail() {
  const { fpoId } = useParams();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [loanDetails, setLoanDetails] = useState([]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [fpoDetails, setFPODetails] = useState({});
  const loanId = searchParams.get("loanId");
  const [isRejectPopupOpen, setIsRejectPopupOpen] = useState(false);
  const [loanProposalFormData, setLoanProposalFormData] = useState({});
  const [openLoanProposalPopup, setOpenLoanProposalPoupup] = useState(false);
  const [comments, setComments] = useState("");
  const rejectField = [
    {
      type: "text",
      label: "Comments",
      name: "comment",
      required: true,
    },
  ];

  const navigate = useNavigate();

  const fetchFPODetails = (fpoId) => {
    api
      .get(`/fpo/get-fpo-details?fpoId=${fpoId}`)
      .then((response) => {
        setFPODetails(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching FPO details:", error);
        setLoading(false);
      });
  };

  const fetchLenderDetails = (loanId) => {
    api
      .get(`/lending/get-loan-request-list/?loan_id=${loanId}`)
      .then((response) => {
        setLoanDetails(response.data);
        console.log(loanDetails);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching lenders:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchFPODetails(fpoId);
    fetchLenderDetails(loanId);
  }, [fpoId, loanId]);

  const handleView = (documentUrl) => {
    window.open(documentUrl, "_blank");
  };

  const handleCardClick = (fpoId) => {
    navigate(`/lender/fpo-farmer-details/${fpoId}`);
  };

  const handleTextFieldChange = (name, value) => {
    if (isRejectPopupOpen) {
      setComments(value);
    } else if (openLoanProposalPopup) {
      setLoanProposalFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleLoanProposalSubmit = (fpoId, loanId) => {
    loanProposalFormData.target_user = fpoId;
    loanProposalFormData.loan_request = loanId;
    api
      .post("lending/create-loan-proposal/", loanProposalFormData)
      .then((response) => {
        console.log("Loan Proposal Response:", response.data);
        alert("Loan Proposal send Successfully");
        setOpenLoanProposalPoupup(false);
        window.location.href = "/lender/requests";
      })
      .catch((error) => {
        console.error("Error making POST request:", error);
        setOpenLoanProposalPoupup(false);
      });
    console.log("submit", loanProposalFormData);
  };

  const infoItems =
    loanDetails && loanDetails.submit_user
      ? [
          { label: "Name", value: `${loanDetails.submit_user.full_name}` },
          { label: "Amount Requested", value: `${loanDetails.amount}` },
          { label: "Loan Type", value: `${loanDetails.loan_type}` },
          {
            label: "Address",
            value: "NA",
          },
          {
            label: "Operational Since",
            value: `${loanDetails.operation_since}`,
          },
          { label: "Revenue", value: `${loanDetails.revenue}` },
          {
            label: "PAN",
            value: loanDetails.submit_user.pan_number
              ? `${loanDetails.submit_user.pan_number}`
              : "Not available",
          },
          { label: "Rate of Interest", value: "NA" },
          { label: "Amount Sanctioned", value: "NA" },
          { label: "Amount Disbursed", value: "NA" },
        ]
      : [];

  const handleAccept = () => {
    api
      .post(`/lending/loan-request/${loanId}/lender-accept/`)
      .then((response) => {
        console.log("Response from accept:", response);
        alert("Offer Accepted");
        setOpenLoanProposalPoupup(true);
      });
  };

  const handleRejectPopup = () => {
    setIsRejectPopupOpen(true);
  };
  const handleReject = () => {
    const payload = {
      status: "rejected",
      comment: comments,
      loan_request: loanId,
    };

    api
      .post(`/lending/loan-request/${loanId}/lender-reject/`, payload)
      .then((response) => {
        console.log("Response from reject:", response);
        alert("Offer Rejected");
        window.location.href = "/lender/requests";
      });
  };

  const loanProposalFields = [
    {
      type: "select",
      label: "Loan Type",
      name: "loan_type",
      options: [
        { value: "working capital", label: "Working Capital" },
        { value: "invoice finance", label: "Invoice Finance" },
        { value: "warehouse finance", label: "Warehouse Finance" },
      ],
      required: true,
    },
    {
      type: "number",
      label: "Amount",
      name: "amount",
      required: true,
    },
    {
      type: "number",
      label: "Enter Rate of Interest %",
      name: "rate",
      required: true,
    },
  ];
  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: "fit-content",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <CustomTitle>{t("Loan Request")}</CustomTitle>
          <div
            style={{
              marginTop: "20px",
            }}
          >
            <Box>
              <>
                {infoItems.map((item, index) => (
                  <Grid container spacing={1} key={index}>
                    <Grid item xs={6}>
                      <Typography variant="body1" fontWeight="bold">
                        {item.label}:
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body1">{item.value}</Typography>
                    </Grid>
                  </Grid>
                ))}
              </>
            </Box>

            {fpoDetails.documents &&
              fpoDetails.documents.map((document) => (
                <div style={{ height: "fit-content" }} key={document.name}>
                  <ListGenericCard
                    title={`${document.name}`}
                    onClick={() => handleView(document.document)}
                  />
                </div>
              ))}

            {fpoDetails.farmers?.length > 0 && (
              <div style={{ height: "fit-content" }}>
                <ListGenericCard
                  title={"Farmer List"}
                  onClick={() => handleCardClick(fpoId)}
                />
              </div>
            )}
          </div>
          {loanDetails.lender_status === "pending" && (
            <div style={{ display: "flex", gap: "15px" }}>
              <CustomButton onClick={handleAccept} hideIcon>
                {t("Accept")}
              </CustomButton>
              <CustomButton
                onClick={handleRejectPopup}
                hideIcon
                backgroundColor="#CF5C5C"
              >
                {t("Reject")}
              </CustomButton>
            </div>
          )}
        </Container>
        <RequestSubmitPopup
          open={isRejectPopupOpen}
          handleClose={() => setIsRejectPopupOpen(false)}
          title="Reject Reason"
          formType="reject"
          textFieldLabel="Reason"
          textFieldValue=""
          handleTextFieldChange={handleTextFieldChange}
          handleSubmit={handleReject}
          customFields={rejectField}
          buttonTitle="Submit"
        />
        <RequestSubmitPopup
          open={openLoanProposalPopup}
          handleClose={() => setOpenLoanProposalPoupup(false)}
          title={"Loan Proposal"}
          textFieldLabel={"Enter something"}
          textFieldValue=""
          handleTextFieldChange={handleTextFieldChange}
          handleSubmit={handleLoanProposalSubmit}
          buttonTitle="Send"
          formType="loanProposal"
          customFields={loanProposalFields}
          loanId={loanId}
          fpoId={fpoId}
        />
      </LoaderContainer>
    </>
  );
}
